<div class="separacion col-12">
  <img src="assets/sobreMi.png" alt="image" height="200">
  <!--<img src="assets/covid19.png" alt="image" height="300" class="imagen-movil">-->
</div>
<div id="sobreMi" class="card-container col-12 row full-height">
    <div class="col-12 col-lg-5 centrar separacion">
      <img src="assets/palomaConBirrete.png" alt="image" height="300" style="margin-top:130px;">
    </div>
    <div class="col-12 col-lg-7 centrar">
      <h1 class="titulo granate">Paloma Calleja Martínez</h1>
      <ul>
        <li>
          <p style="margin-bottom: 0px;">Licenciada en <span class="naranja">Psicología educativa</span> por la Universidad Complutense de Madrid.</p>
        </li>
        <li>
          <p style="margin-bottom: 0px;">Máster en <span class="naranja">Orientación educativa</span> por la Universidad Complutense de Madrid.</p>
        </li>
        <li>
          <p style="margin-bottom: 0px;">Especialista en <span class="naranja">Pedagogía terapéutica</span> por la Universidad Nacional de Educación a Distancia.</p>
        </li>
        <li>
          <p>Máster en Orientación e <span class="naranja">Intervención Psicopedagógica</span> por la Universidad Camilo José Cela.</p>
        </li>
      </ul>
      <h1 class="titulo granate">Cursos de formación complementaria</h1>
      <ul>
        <li>
          <p style="margin-bottom: 0px;">La <span class="naranja">inteligencia emocional</span> en las distintas etapas educativas. Magíster.</p>
        </li>
        <li>
          <p style="margin-bottom: 0px;">Intervención en <span class="naranja">di­ficultades de aprendizaje</span>. Integratek</p>
        </li>
        <li>
          <p style="margin-bottom: 0px;">Manejo del <span class="naranja">bullying</span> en ámbito educativo. ANFAP.</p>
        </li>
        <li>
          <p style="margin-bottom: 0px;">Máster en <span class="naranja">Resolución de Conflictos</span>. Divulgación Dinámica.</p>
        </li>
        <li>
          <p style="margin-bottom: 0px;">La <span class="naranja">Atención a la Diversidad</span> en la Educación Infantil, Primaria y Secundaria. Universidad Camilo José Cela.</p>
        </li>
        <li>
          <p style="margin-bottom: 0px;">La colaboración y participación de la <span class="naranja">familia</span> en la escuela en las distintas etapas educativas. Universidad Francisco de Vitoria.</p>
        </li>
        <li>
          <p style="margin-bottom: 0px;">La intervención con alumnos con <span class="naranja">Trastorno Generalizado del Desarrollo</span> en las distintas etapas educativas. Universidad Francisco de Vitoria.</p>
        </li>
        <li>
          <p>La <span class="naranja">tutoría</span> en la escuela. UNED.</p>
        </li>
      </ul>
    </div>
</div>